(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/my-profile-react/assets/react/shared/components/pd-items-menu.js') >= 0) return;  svs.modules.push('/modules/my-profile-react/assets/react/shared/components/pd-items-menu.js');
'use strict';

const {
  useLocation
} = ReactRouterDOM;
const {
  ItemsMenu,
  IconItem
} = svs.ui.ReactItemsMenu;
const {
  Link
} = ReactRouterDOM;
const {
  routes
} = svs.myProfile.constants;
const {
  getCustomersPreferences
} = svs.myProfile.react.store.pdPreferences.actions;
const makeParams = cAndI => {
  const {
    c,
    i
  } = cAndI;
  if (!c || !i) {
    return '';
  }
  return "?c=".concat(c, "&i=").concat(i);
};

const PdItemsMenu = () => {
  const location = useLocation();
  const {
    cAndI
  } = ReactRedux.useSelector(state => state.playerDetails);
  const {
    playerPreferences
  } = ReactRedux.useSelector(state => state.playerPreferences);
  const dispatch = ReactRedux.useDispatch();
  const params = makeParams(cAndI);
  const [pages, setPages] = React.useState(() => [{
    href: routes.MY_PROFILE_NOTIFICATIONS + params,
    iconName: 'notifications',
    label: 'Spelnotifieringar',
    altHrefs: [routes.MY_PROFILE_NOTIFICATIONS]
  }, {
    href: routes.MY_PROFILE_COMMUNICATION + params,
    iconName: 'e-post',
    label: 'Kommunikation',
    altHrefs: [routes.MY_PROFILE_COMMUNICATION, routes.MY_PROFILE_COMMUNICATION_ADAPT_CONTENT]
  }]);
  React.useEffect(() => {
    dispatch(getCustomersPreferences());
  }, []);
  React.useEffect(() => {
    const isPlayerLoggedIn = svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER);
    if (isPlayerLoggedIn) {
      const newPages = pages.slice();
      const findUppgifter = pages.findIndex(p => p.href === routes.MY_PROFILE_HOME);
      if (findUppgifter === -1) {
        newPages.unshift({
          href: routes.MY_PROFILE_HOME,
          iconName: 'my-settings',
          label: 'Mina\u{00A0}uppgifter',
          altHrefs: [routes.MY_PROFILE_INFORMATION, routes.MY_PROFILE_PLAYERDETAILS_CHANGE_EMAIL, routes.MY_PROFILE_PLAYERDETAILS_CONFIRM_EMAIL, routes.MY_PROFILE_PLAYERDETAILS_MISSING_EMAIL, routes.MY_PROFILE_PLAYERDETAILS_CHANGE_MOBILE, routes.MY_PROFILE_PLAYERDETAILS_CONFIRM_MOBILE, routes.MY_PROFILE_TRANSCRIPT]
        });
      }
      if ((playerPreferences === null || playerPreferences === void 0 ? void 0 : playerPreferences.showKyc) === '1') {
        const findKyc = pages.findIndex(p => p.href === routes.MY_PROFILE_KYC);
        if (findKyc === -1) {
          newPages.push({
            href: routes.MY_PROFILE_KYC,
            iconName: 'document',
            label: 'Kundkännedom',
            altHrefs: [routes.MY_PROFILE_KYC_QUESTIONS]
          });
        }
      }
      setPages(newPages);
    }
  }, [playerPreferences === null || playerPreferences === void 0 ? void 0 : playerPreferences.showKyc]);
  return React.createElement(ItemsMenu, {
    branding: "neutral",
    centered: true,
    customer: "neutral",
    useScrollFaders: true
  }, pages.map(_ref => {
    let {
      href,
      iconName,
      label,
      altHrefs
    } = _ref;
    return React.createElement(IconItem, {
      alignment: "vertical",
      Component: Link,
      gutter: 1,
      iconName: iconName,
      id: "".concat(label.toLowerCase(), "Nav"),
      isSelected: (location === null || location === void 0 ? void 0 : location.pathname) === href || (altHrefs === null || altHrefs === void 0 ? void 0 : altHrefs.includes(location === null || location === void 0 ? void 0 : location.pathname)),
      key: label,
      label: label,
      minWidth: 125,
      to: href
    });
  }));
};
svs.myProfile.react.shared.components.PdItemsMenu = PdItemsMenu;

 })(window);